import { getAuthToken } from "../../../auth/authClient";

const API_BASE = (process.env.REACT_APP_MORFEUSZ_4E_API_URL || "").replace(/\/$/, "");

const vaultUrl = (path = "") => `${API_BASE}/vault${path}`;

const requestHeaders = (options = {}) => {
  const token = getAuthToken();
  return {
    ...(options.body ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };
};

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.ok) {
    const error = new Error(data?.message || `vault-http-${response.status}`);
    error.code = data?.code || `vault-http-${response.status}`;
    error.status = response.status;
    throw error;
  }
  return data;
};

const request = async (path = "", options = {}) => {
  if (!API_BASE) {
    const error = new Error("vault-api-missing");
    error.code = "vault-api-missing";
    throw error;
  }

  const response = await fetch(vaultUrl(path), {
    credentials: "include",
    ...options,
    headers: requestHeaders(options),
  });
  return parseResponse(response);
};

export const vaultClient = {
  isConfigured: () => Boolean(API_BASE),
  status: () => request("/status"),
  setup: (payload) => request("/setup", { method: "POST", body: JSON.stringify(payload) }),
};
